import { Link } from 'react-router-dom';
import './Footer.css';

const contactEmail = process.env.REACT_APP_PUBLIC_CONTACT_EMAIL?.trim();

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-modern" role="contentinfo">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-main">
          <div className="footer-grid">
            {/* Brand Section */}
            <div className="footer-section footer-brand-section">
              <div className="footer-logo-wrapper">
                <h2 className="footer-logo">Alwaysaligners</h2>
                <p className="footer-tagline">Formación especializada para profesionales</p>
              </div>
              <p className="footer-description">
                Plataforma de aprendizaje en línea diseñada para profesionales dentales 
                que buscan mejorar sus habilidades y conocimientos.
              </p>
              <div className="footer-badges">
                <span className="footer-badge">
                  <i className="fas fa-certificate"></i>
                  Certificados
                </span>
                <span className="footer-badge">
                  <i className="fas fa-users"></i>
                  Expertos
                </span>
              </div>
            </div>

            {/* Quick Links Section */}
            <div className="footer-section">
              <h3 className="footer-section-title">Enlaces Rápidos</h3>
              <ul className="footer-links-list">
                <li>
                  <Link to="/courses" className="footer-link">
                    <i className="fas fa-graduation-cap"></i>
                    Cursos
                  </Link>
                </li>
                <li>
                  <Link to="/my-courses" className="footer-link">
                    <i className="fas fa-book-open"></i>
                    Mis Cursos
                  </Link>
                </li>
                <li>
                  <Link to="/" className="footer-link">
                    <i className="fas fa-home"></i>
                    Inicio
                  </Link>
                </li>
                <li>
                  <Link to="/terminos" className="footer-link">
                    <i className="fas fa-info-circle"></i>
                    Ayuda legal
                  </Link>
                </li>
              </ul>
            </div>

            {/* Support Section */}
            <div className="footer-section">
              <h3 className="footer-section-title">Soporte</h3>
              <ul className="footer-links-list">
                <li>
                  <a href="/pages/ayuda.html" className="footer-link">
                    <i className="fas fa-question-circle"></i>
                    Ayuda
                  </a>
                </li>
                <li>
                  <Link to="/terminos" className="footer-link">
                    <i className="fas fa-file-contract"></i>
                    Términos y Condiciones
                  </Link>
                </li>
                <li>
                  <Link to="/privacidad" className="footer-link">
                    <i className="fas fa-shield-alt"></i>
                    Política de Privacidad
                  </Link>
                </li>
                <li>
                  <Link to="/privacidad" className="footer-link">
                    <i className="fas fa-comments"></i>
                    Datos personales
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact Section */}
            <div className="footer-section">
              <h3 className="footer-section-title">Contacto</h3>
              <ul className="footer-contact-list">
                <li>
                  <i className="fas fa-envelope"></i>
                  {contactEmail ? (
                    <a href={`mailto:${contactEmail}`} className="footer-link">
                      {contactEmail}
                    </a>
                  ) : (
                    <span>Definí REACT_APP_PUBLIC_CONTACT_EMAIL en el build</span>
                  )}
                </li>
                <li>
                  <i className="fas fa-phone"></i>
                  <span>{process.env.REACT_APP_PUBLIC_PHONE?.trim() || '—'}</span>
                </li>
                <li>
                  <i className="fas fa-map-marker-alt"></i>
                  <span>Buenos Aires, Argentina</span>
                </li>
              </ul>
              <div className="footer-social">
                <a 
                  href="https://facebook.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label="Facebook"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a 
                  href="https://instagram.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label="Instagram"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a 
                  href="https://linkedin.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label="LinkedIn"
                >
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a 
                  href="https://youtube.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label="YouTube"
                >
                  <i className="fab fa-youtube"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="footer-copyright">
              &copy; {currentYear} Alwaysaligners. Todos los derechos reservados.
            </p>
            <div className="footer-legal-links">
              <Link to="/terminos" className="footer-legal-link">
                Términos
              </Link>
              <span className="footer-separator">•</span>
              <Link to="/privacidad" className="footer-legal-link">
                Privacidad
              </Link>
              <span className="footer-separator">•</span>
              <Link to="/cookies" className="footer-legal-link">
                Cookies
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
